<template>
  <div class="table_one_warp">
    <el-table :cell-style="getRowClass" :header-cell-style="getRowClass" max-height="250" :data="reverseTableData"
      style="width: 80%">
      <el-table-column type="expand">
        <template slot-scope="props">
          <pre v-html="props.row.content" class="table_onde_warp_content"></pre>
        </template>
      </el-table-column>
      <el-table-column width="160px" label="时间" prop="logtime">
      </el-table-column>
      <el-table-column label="状态" width="60px" :formatter="formatter" prop="state">
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="部署SQL语句" prop="sqlcontent">
        <template slot-scope="scope">
          <div class="table_five_row"><span>{{ scope.row.sqlcontent }}</span><i v-if="scope.row.sqlcontent"
              class="el-icon-document-copy" @click="handleClickCopy(scope.row.sqlcontent)"></i></div>
        </template>
      </el-table-column>
      <el-table-column v-if="moduleType === 'odoo'" :show-overflow-tooltip="true" label="GIT部署路径"
        prop="deploy_filepath">
        <template slot-scope="scope">
          <div class="table_five_row"><span>{{ scope.row.deploy_filepath }}</span><i v-if="scope.row.deploy_filepath"
              class="el-icon-document-copy" @click="handleClickCopy(scope.row.deploy_filepath)"></i></div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    moduleType: {
      type: String,
      default: () => {
        return ''
      }
    }

  },
  data() {
    return {
      tableDataInit: [
        {
          content: "",
          logtime: "",
          deploy_filepath: "",
          sqlcontent: ""
        },
      ],
    };
  },
  computed: {
    reverseTableData: function () {
      // if (this.moduleType) {
      //   return this.tableData.reverse().filter(itm => {
      //     return this.moduleType === itm.module_type
      //   })
      // }
      return this.tableData.reverse();
    },
  },
  methods: {
    getRowClass({ row, column, rowIndex, columnIndex }) {
      // console.log(row, column, rowIndex, columnIndex)
      if(row.state === 0 && columnIndex === 2){
        return "background:#f1fbec;color:#67C23A;";
      }
      if(row.state !== 0 && columnIndex === 2 && row.state){
        return "background:#f1fbec;color:#F56C6C;";
      }
      return "background:#f1fbec";
    },
    handleClickCopy(val) {
      this.$copyText(val).then((res) => {
        this.$notify({
          message: '复制成功',
          type: 'success'
        })
        console.log("内容已复制到剪切板！，复制的内容为：" + res.text)
      }).catch(err => {
        this.$notify({
          message: '复制失败',
          type: 'error'
        })
        console.log("抱歉，复制失败！")
      })
    },
    formatter(row, column) {
      return row.state === 0 ? '成功' : '失败'
    }
  },
};
</script>
<style lang="scss" scoped>
.table_one_warp {
  background: #f1fbec;
}

.table_onde_warp_content {
  white-space: pre-wrap;
}
</style>

<style  lang="scss">
.table_one_warp {
  .table_five_row {
    display: flex;

    span {
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 90%;
    }

    i {
      margin-top: 5px;
      display: none;
      cursor: pointer;
      margin-left: 5px;
    }

    &:hover i {
      display: block;
    }
  }

  .demo-table-expand {
    font-size: 0;
  }

  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }

  .el-table__body-wrapper {
    scrollbar-width: thin;
    scrollbar-color: skyblue #eee;
  }

  .el-table__body-wrapper::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }

  .el-table__body-wrapper::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    background-color: skyblue;
    background-image: -webkit-linear-gradient(45deg,
        rgba(255, 255, 255, 0.2) 25%,
        transparent 25%,
        transparent 50%,
        rgba(255, 255, 255, 0.2) 50%,
        rgba(255, 255, 255, 0.2) 75%,
        transparent 75%,
        transparent);
  }

  .el-table__body-wrapper::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #ededed;
    border-radius: 10px;
  }
}
</style>
